import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 80,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textMessage: {
    marginTop: -100,
    padding: '0 24px',
    fontWeight: 500,
    fontSize: 32,
    textAlign: 'center',
    color: theme.colors.light.lightCyan,
  },
  buttonGroup: {
    width: '100%',
    marginTop: 40,
    padding: '0 24px',
  },
  buttonSeparator: {
    margin: '0 0 16px 0',
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    color: theme.colors.light.lightSteelBlue,
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '45%',
      height: 1,
      backgroundColor: theme.colors.light.lightSteelBlue,
      position: 'absolute',
      top: '50%',
      zIndex: 1,
      transform: 'translateY(-50%)',
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    },
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    height: 46,
    width: '100%',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
